import AgConfirmationModal from '@/components/common/ModalWindow/AgConfirmationModal';

interface UnassignPurchaseOrderModalProps {
  isOpen: boolean;
  totalLinesCount: number;
  onConfirm: () => void;
  onClose: () => void;
}

export default function UnassignPurchaseOrderModal(
  { isOpen, totalLinesCount, onConfirm, onClose, }: UnassignPurchaseOrderModalProps) {

  return (
        <AgConfirmationModal
            isOpen={isOpen}
            contentStyle={{ width: 600 }}
            title={`Unassign Purchase Order ${totalLinesCount > 1 ? ` to ${totalLinesCount} lines` :
              totalLinesCount > 0 ? ` to ${totalLinesCount} line` : ''}`}
            onConfirm={onConfirm}
            onClose={onClose}>
            You are about to unassign the Purchase Order from {
              totalLinesCount > 1
                ? `${totalLinesCount} contract lines`
                : totalLinesCount > 0
                  ? ` ${totalLinesCount} contract line`
                  : ''
            }.<br />
            Please confirm you wish to continue.
        </AgConfirmationModal >
  );
}
